module.exports = __webpack_public_path__ + "img/Zuilen_pin_blanco_v2.b54dfd3d.svg";